import type { NotificationDto } from "@ied/shared-types";
import { useQuery } from "@tanstack/react-query";
import { SERVICE_API } from "@/lib/consts";

export function useGetNotifications() {
	return useQuery({
		queryKey: ["notifications"],
		queryFn: async () => {
			const res = await fetch(`${SERVICE_API}/api/notifications`, {
				credentials: "include",
				headers: {
					"Content-Type": "application/json",
				},
			});
			if (!res.ok) {
				throw new Error("Unable to notifications");
			}

			return (await res.json()) as NotificationDto[];
		},
	});
}
